export default class Config {
  static getAllPagesConfig() {
    return new Promise((resolve) => {
      const overviewConfig = this.getPageConfig(
        "overview",
        "./config/PagesConfig/OverviewExecutivo.json"
      );

      Promise.all([overviewConfig]).then((values) => {
        const config = {};
        for (let i = 0; i < values.length; i += 1) {
          const item = values[i];
          config[item.configName] = item;
        }
        resolve(config);
      });
    });
  }

  static getPageConfig(name, path) {
    return new Promise((resolve) => {
      fetch(path).then((response) => {
        response.json().then((res) => {
          const data = res;
          data.configName = name;
          resolve(data);
        });
      });
    });
  }
}
